<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
              <BTab  :title="$t('create')">
                <AddReminder/>
              </BTab>
              <BTab  :title="$t('list')">
                <ListReminder/>
              </BTab>
              <BTab  :title="$t('weekDays')">
                <WeekReminder/>
              </BTab>
              <BTab  :title="$t('contacts')">
                <Contacts/>
              </BTab>
            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
  import axios from "axios";
  import {bus} from '../../../main';
  import BTabs from "../../tabs/BTabs";
import Contacts from "../settings/Contacts";
 import AddReminder from "./AddReminder";
 import ListReminder from "./ListReminder";
 import WeekReminder from "./WeekReminder";
  import BTab from "../../tabs/BTab";
  export default {
    name: 'Login',
    components: {
      BTab,
      BTabs,
      Contacts,
      AddReminder,
      ListReminder,
      WeekReminder,

    },
    data() {
      return {

        active_tab:parseInt(localStorage.getItem("reminder_active_tab",0)),

      }
    }, mounted() {

    }, watch: {

    },
    methods: {

    }
  }

</script>

